import React from 'react';
import {Button, Modal} from "react-bootstrap";
import Moment from "react-moment";
import {deleteEvent} from "../../../api/Events";

function EventDelete(props) {
    const [modalShow, setModalShow] = React.useState(false);

    return (
        <>
            <Button style={{marginLeft: 20}} variant="danger" onClick={() => setModalShow(true)}>Supprimer</Button>

            <WarningModal
                show={modalShow}
                id={props.id}
                title={props.title}
                date={props.date}
                onHide={() => setModalShow(false)}
            />
        </>
    );
}

function WarningModal(props) {
    async function handleDelete() {
        const deleted = await deleteEvent(props.id);
        console.log(deleted.status)
        if (deleted.status === 200) {
            window.location.href = "/events"
        }

    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Confirmation de suppression
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Êtes-vous sur de vouloir supprimer l'événements <b>"{props.title}"</b> du <b><Moment date={props.date} format="DD.MM.YYYY"/></b> ?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>Annuler</Button>
                <Button variant="danger" onClick={handleDelete}>Confirmer</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EventDelete;
